import { SUPPORT } from "icons";
import { NavItemWithBadge } from "@/components/nav/nav-item-with-badge";

export function SupportNavigations() {
  return (
    <NavItemWithBadge
      title="Support"
      icon={SUPPORT}
      url="/support"
      requiredPermissions={{
        type: "collection",
        collection: "tickets",
      }}
    />
  );
}
